<template>
  <main-layout
    class="pro-expired-page"
    :page-title="text.planTitle"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="expired-card">
        <order-info-card :order="order" />
        <div class="expired-panel">
          <img class="expired-icon" :src="clockIcon" alt="" />
          <p class="expired-text">{{ text.orderExpired }}</p>
          <div class="expired-actions">
            <span class="link" @click="goWorkbench">{{
              text.backWorkbench
            }}</span>
            <span class="btn-primary" @click="reorder">{{ text.reorder }}</span>
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import OrderInfoCard from "./components/OrderInfoCard.vue";
import { PRO_PLAN_TEXT } from "@/consts/proPlan";
import { getProOrderDetail } from "@/api/request/snkd.proPlan";
import { windowHref } from "@/utils";

export default {
  name: "ProPlanOrderExpired",
  components: { MainLayout, OrderInfoCard },
  data() {
    return {
      text: PRO_PLAN_TEXT,
      order: {},
      clockIcon: require("@/assets/images/pro-plan/plan/order-expired-clock.png"),
    };
  },
  async created() {
    const res = await getProOrderDetail({
      companyId: this.$route.query.companyId,
      orderId: this.$route.query.orderId,
    });
    this.order = res.obj || {};
  },
  methods: {
    goWorkbench() {
      // 返回老端工作台（本项目为扩展端，老端首页为 /home/home）
      windowHref("/home/home");
    },
    reorder() {
      this.$router.replace({
        path: "/proPlan/index",
        query: { companyId: this.$route.query.companyId },
      });
    },
    goBack() {
      window.history.length > 1 ? this.$router.back() : window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  min-height: 100%;
  // 顶部留白由卡片 margin 提供，此处不再加 padding-top（与确认页一致，禅道 Bug#23429-1）
  padding: 0 0 30px;
  box-sizing: border-box;
  background: #f7f9fb;
}
.expired-card {
  width: 1100px;
  min-height: 386px;
  // 与订单确认页保持一致：设计稿卡片绝对 y=109、头部高 80 → 头部到卡片实际间距 29px。
  // 原先写 109px（设计稿的绝对坐标，含头部高度）＋ .main-content 的 30px padding-top，
  // 实测顶部留白达 139px，明显大于确认页的 29px。
  margin: 29px auto 0;
  padding: 39px 165px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
}
.expired-panel {
  padding-top: 62px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.expired-icon {
  width: 120px;
  height: 120px;
  display: block;
}
.expired-text {
  margin: 10px 0 0;
  font-size: 20px;
  font-weight: 700;
  color: #a8b8c5;
}
.expired-actions {
  margin-top: 30px;
  display: flex;
  align-items: center;
  gap: 30px;
  .link {
    font-size: 15px;
    color: #64c3a4;
    cursor: pointer;
  }
  .btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 15px;
    font-size: 15px;
    color: #fff;
    background: #64c3a4;
    border-radius: 30px;
    cursor: pointer;
  }
}
</style>
